export const FORGOT_PASSWORD_FORM_EMAIL = 'email'


// WEBPACK FOOTER //
// ./src/constants/ForgotPasswordFormFieldName.tsx